import { formatCurrency } from '@iheartjane/utils';

import { labelForVal } from '@jane/shared/util';

/**
 * A product's prices collapsed across the weights it is sold in. `weights` are
 * the price columns that carry a price, ex `price_gram`.
 */
export interface PriceRange {
  max: number;
  min: number;
  weights: string[];
}

/** Renders "$18.00" when min and max match, "$18.00-$22.00" otherwise */
const priceLabel = ({ max, min }: PriceRange): string =>
  min === max
    ? formatCurrency(min)
    : `${formatCurrency(min)}-${formatCurrency(max)}`;

/**
 * The "Price/Weight" cell. One weight is labelled by name (`$18.00/1g`);
 * several are counted (`$40.00-$120.00/3 weights`).
 */
export const priceWeightLabel = (range?: PriceRange): string => {
  const [only, ...rest] = range?.weights ?? [];

  if (!range || !only) return '';

  return rest.length === 0
    ? `${priceLabel(range)}/${labelForVal(only) ?? only}`
    : `${priceLabel(range)}/${rest.length + 1} weights`;
};
